var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _circle, _path12, _g2, _path13, _path14, _path15, _path16, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 209 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#797882",
    fillRule: "nonzero",
    d: "M152.843 56.129H23.244v48.828h143.289l-13.69-48.828z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacb2",
    d: "M23.244 56.131H100.935V104.959H23.244z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M60.209 30.348H90.31800000000001V50.882999999999996H60.209z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2e30",
    d: "M75.455 30.348H90.317V50.882999999999996H75.455z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d2217",
    fillRule: "nonzero",
    d: "M90.315 37.191H60.207a6.845 6.845 0 110-13.689h30.108a6.845 6.845 0 010 13.689z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M31.001 6.847H50.952V56.131H31.001z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2e30",
    d: "M40.915 6.847H50.954V56.131H40.915z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#de3205",
    fillRule: "nonzero",
    d: "M50.952 13.69H31.001a6.845 6.845 0 010-13.69h19.951a6.845 6.845 0 110 13.69z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacb2",
    fillRule: "nonzero",
    d: "M161.057 62.974H22.331a6.845 6.845 0 110-13.689h138.726a6.845 6.845 0 110 13.689z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3e42",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.657 77.548h-4.536a2.738 2.738 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.537a2.737 2.737 0 01-2.738 2.737zM65.35 77.548h-4.536a2.737 2.737 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.537a2.737 2.737 0 01-2.738 2.737zM82.043 77.548h-4.537a2.738 2.738 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.537a2.738 2.738 0 012.738 2.738v4.537a2.737 2.737 0 01-2.738 2.737zM98.736 77.548H94.2a2.737 2.737 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.537a2.737 2.737 0 01-2.738 2.737zM115.429 77.548h-4.536a2.738 2.738 0 01-2.739-2.738v-4.536a2.738 2.738 0 012.739-2.738h4.536a2.738 2.738 0 012.738 2.738v4.537a2.737 2.737 0 01-2.738 2.737zM132.122 77.548h-4.536a2.737 2.737 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.537a2.737 2.737 0 01-2.738 2.737zM57.514 92.181h-4.536a2.737 2.737 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.536a2.738 2.738 0 01-2.738 2.738zM76.944 89.443a2.737 2.737 0 01-2.738 2.738H69.67a2.738 2.738 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.536zM93.638 89.443a2.738 2.738 0 01-2.739 2.738h-4.536a2.738 2.738 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.739 2.738v4.536zM107.593 92.181h-4.537a2.738 2.738 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.537a2.738 2.738 0 012.738 2.738v4.536a2.738 2.738 0 01-2.738 2.738zM124.286 92.181h-4.536a2.738 2.738 0 01-2.739-2.738v-4.536a2.738 2.738 0 012.739-2.738h4.536a2.738 2.738 0 012.738 2.738v4.536a2.738 2.738 0 01-2.738 2.738zM143.716 89.443a2.737 2.737 0 01-2.738 2.738h-4.536a2.738 2.738 0 01-2.738-2.738v-4.536a2.738 2.738 0 012.738-2.738h4.536a2.738 2.738 0 012.738 2.738v4.536z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e3",
    fillRule: "nonzero",
    d: "M174.217 155.201a28.113 28.113 0 01-23.39 12.518H36.585c-14.25 0-26.246-10.663-27.917-24.815l-4.719-39.979a5.939 5.939 0 015.9-6.638h192.543a5.943 5.943 0 014.944 9.236l-33.119 49.678z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacb2",
    fillRule: "nonzero",
    d: "M100.935 96.287v71.432h49.892a28.11 28.11 0 0023.389-12.518l33.118-49.678a5.94 5.94 0 00-4.943-9.236H100.935z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.215,
    cy: 117.052,
    r: 8.898,
    fill: "#2d2e30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    fillRule: "nonzero",
    d: "M39.215 125.949a8.899 8.899 0 010-17.797v17.797z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2d2e30"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.075,
    cy: 117.052,
    r: 8.898
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.937,
    cy: 117.052,
    r: 8.898
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.794,
    cy: 117.052,
    r: 8.898
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.656,
    cy: 117.052,
    r: 8.898
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d94b9",
    fillRule: "nonzero",
    d: "M103.714 176.283a19.167 19.167 0 01-13.646-5.652 5.573 5.573 0 00-3.966-1.643 5.57 5.57 0 00-3.966 1.643 19.174 19.174 0 01-13.647 5.652 19.17 19.17 0 01-13.647-5.652 5.615 5.615 0 00-7.932 0 19.171 19.171 0 01-13.646 5.652 19.165 19.165 0 01-13.646-5.652 5.576 5.576 0 00-3.967-1.643 5.571 5.571 0 00-3.966 1.643 6.845 6.845 0 01-9.68-9.68 19.172 19.172 0 0113.646-5.653 19.17 19.17 0 0113.647 5.653 5.572 5.572 0 003.966 1.642 5.572 5.572 0 003.966-1.642 19.172 19.172 0 0113.646-5.653 19.17 19.17 0 0113.647 5.653 5.572 5.572 0 003.966 1.642 5.572 5.572 0 003.966-1.642 19.175 19.175 0 0113.647-5.653 19.168 19.168 0 0113.646 5.653 5.617 5.617 0 007.933 0c7.524-7.525 19.768-7.525 27.293 0a5.572 5.572 0 003.966 1.642 5.574 5.574 0 003.966-1.642c7.524-7.525 19.768-7.525 27.293 0a5.57 5.57 0 003.966 1.642 5.574 5.574 0 003.966-1.642c7.524-7.525 19.768-7.525 27.293 0a6.845 6.845 0 11-9.681 9.68 5.572 5.572 0 00-3.966-1.643 5.571 5.571 0 00-3.966 1.643c-7.524 7.525-19.768 7.525-27.293 0a5.572 5.572 0 00-3.966-1.643 5.571 5.571 0 00-3.966 1.643c-7.524 7.525-19.768 7.525-27.292 0a5.616 5.616 0 00-7.933 0 19.174 19.174 0 01-13.647 5.652z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d2217",
    fillRule: "nonzero",
    d: "M186.112 137.357H8.014l.654 5.547c.034.283.078.562.12.842h173.065l4.259-6.389z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#de3205",
    fillRule: "nonzero",
    d: "M100.935 137.357H8.014l.654 5.547c.034.283.078.562.119.842h92.148v-6.389z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e3",
    fillRule: "nonzero",
    d: "M100.935 49.284H22.331a6.845 6.845 0 000 13.69h78.604v-13.69z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#57565c",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.075 125.949a8.899 8.899 0 010-17.797v17.797zM100.935 125.949a8.899 8.899 0 110-17.797v17.797zM131.795 125.949a8.899 8.899 0 110-17.797v17.797zM162.654 125.949a8.899 8.899 0 010-17.797v17.797z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipWave);
export default __webpack_public_path__ + "static/media/ship-wave.11b90f531262000c679feb4f8412aa7b.svg";
export { ForwardRef as ReactComponent };